import { HttpErrorResponse } from "@angular/common/http";
import * as lodash from "lodash";

export interface ProblemDetails {
  traceId: string;
  type: string;
  title: string;
  detail: string;
  status: number;
  errors?: { [key: string]: string };
}

export function handleError(response: HttpErrorResponse): string {
  switch (response.status) {
    case 0: {
      return "The service appears to be offline or disconnected from network.";
    }
    case 401: {
      return "Access denied (401)! You do not have permission to access this service.";
    }
    case 403: {
      return "Forbidden (403)! You do not have permission to access this service.";
    }
    case 400: {
      if (response.error && typeof response.error === "string") {
        return response.error;
      }
      const badRequest = response.error as ProblemDetails;
      if (badRequest) {
        return stringify(badRequest, true);
      }
      return response.error && response.error.message ? response.error.message : response.message;
    }
    case 404:
      if (response.error && typeof response.error === "string") {
        return response.error;
      }
      const notFound = response.error as ProblemDetails;
      if (notFound) {
        return stringify(notFound);
      }
      return response.error && response.error.message ? response.error.message : response.message;
    case 500: {
      if (response.error && typeof response.error === "string") {
        return response.error;
      }
      const serverError = response.error as ProblemDetails;
      if (response.error) {
        return stringify(serverError);
      }
      return response.error && response.error.message ? response.error.message : response.message;
    }
    default:
      return response.error && response.error.message ? response.error.message : response.message;
  }
}

function stringify(error: ProblemDetails, includeErrors?: boolean) {
  const defaultErrorResponses = ["Internal Server Error", "Not Found", "Bad Request"];
  let message = "";
  if (error.title && !defaultErrorResponses.includes(error.title)) {
    message += error.title;
  }
  if (error.detail) {
    message += message ? ` (Details: ${error.detail})` : error.detail;
  }
  if(error.traceId){
    message += message ? ` (TraceId: ${error.traceId})` : error.traceId;
  }

  if (!lodash.isEmpty(error.errors) && includeErrors) {
    message += "<ul class=\"mb-0\">";
    for (const key of Object.keys(error.errors)) {
      for (const index of Object.keys(error.errors[key])) {
        message += `<li>${error.errors[key][index]}</li>`;
      }
    }
    message += "</ul>";
  }
  return message;
}
